import * as actionTypes from './cloneSchedule.actionTypes';
import { HIDE_LOADER, SHOW_LOADER } from '../../../constants/actionTypes';

const initialState = {
  isLoading: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CREATE_CLONE_SUCCESS:
      return Object.assign({}, state, action.payload);
    case SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.CREATE_CLONE:
          return Object.assign({}, state, { isLoading: true });
        default:
          return Object.assign({}, state);
      }
    case HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.CREATE_CLONE:
          return Object.assign({}, state, { isLoading: false });
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
